<mat-paginator 
[length]="length" 
[pageSize]="pageSize" 
(page)="handlePageEvent($event)"
[showFirstLastButtons]="showFirstLastButtons"
[pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
[hidePageSize]="hidePageSize">
</mat-paginator>
